@if (triggerForm) {
  <div
    [formGroup]="triggerForm"
    class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-end"
  >
    <!-- Cadence -->
    <div
      class="tw-reset tw-col-span-12 md:tw-col-span-4 tw-pb-2"
      #cadenceSelect
    >
      <da-dropdown
        #cadenceDropdown
        [config]="cadenceDropdownConfig"
        [value]="selectedCadenceItems()"
        (selectionChange)="
          setCadence($event, cadenceDropdown, cadenceSelectList)
        "
      >
        <da-select-list
          #cadenceSelectList
          [config]="cadenceSelectListConfig"
          [selectionValues]="cadenceDropdown.selectedItems()"
          (overlayChanges)="cadenceDropdown.onSelectionUpdate($event)"
          (popoverClosing)="cadenceDropdown.closePopover()"
        />
      </da-dropdown>
      @if (!cadenceControl.valid && triggerForm.touched) {
        <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
          {{ i18nShared.Core_FieldRequired }}
        </div>
      }
    </div>

    <!-- Day (weekly) -->
    @if (cadenceControl.value === TriggerScheduleType.Weekly) {
      <div class="tw-reset tw-col-span-12 md:tw-col-span-5 tw-pb-2" #daySelect>
        <da-dropdown
          #weeklyDayDropdown
          [config]="dayDropdownConfig"
          [value]="selectedDayItems()"
          (selectionChange)="
            setDay($event, weeklyDayDropdown, weeklyDaySelectList)
          "
        >
          <da-select-list
            #weeklyDaySelectList
            [config]="weeklyDaySelectListConfig"
            [selectionValues]="weeklyDayDropdown.selectedItems()"
            (overlayChanges)="weeklyDayDropdown.onSelectionUpdate($event)"
            (popoverClosing)="weeklyDayDropdown.closePopover()"
          />
        </da-dropdown>
        @if (!dayControl.valid && triggerForm.touched) {
          <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
            {{ i18nShared.Core_FieldRequired }}
          </div>
        }
      </div>
    }
    <!-- Day (monthly) -->
    @if (cadenceControl.value === TriggerScheduleType.Monthly) {
      <div class="tw-reset tw-col-span-12 md:tw-col-span-5 tw-pb-2" #daySelect>
        <da-dropdown
          #monthlyDayDropdown
          [config]="dayDropdownConfig"
          [value]="selectedDayItems()"
          (selectionChange)="
            setDay($event, monthlyDayDropdown, monthlyDaySelectList)
          "
        >
          <da-select-list
            #monthlyDaySelectList
            [config]="monthlyDaySelectListConfig"
            [selectionValues]="monthlyDayDropdown.selectedItems()"
            (overlayChanges)="monthlyDayDropdown.onSelectionUpdate($event)"
            (popoverClosing)="monthlyDayDropdown.closePopover()"
          />
        </da-dropdown>
        @if (!dayControl.valid && triggerForm.touched) {
          <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
            {{ i18nShared.Core_FieldRequired }}
          </div>
        }
      </div>
    }

    <!-- Specified date (once-off) -->
    @if (isSpecifiedDateRequired(cadenceControl.value)) {
      <div class="tw-reset tw-col-span-12 md:tw-col-span-5">
        <da-datepicker
          #dateSelect
          inputId="schedule-specified-date"
          [label]="i18n.Automation_Schedule_Date"
          formControlName="specifiedDate"
          [min]="todayDate"
          [errorOverrides]="
            !specifiedDateControl.valid && triggerForm.touched
              ? specifiedDateControl.errors
              : null
          "
        />
      </div>
    }

    <!-- Time -->
    <div class="tw-reset tw-col-span-12 md:tw-col-span-3 tw-pb-2" #timeSelect>
      <da-dropdown
        #timeDropdown
        [config]="timeDropdownConfig"
        [value]="selectedTimeItems()"
        (selectionChange)="setTime($event, timeDropdown, timeSelectList)"
      >
        <da-select-list
          #timeSelectList
          [config]="timeSelectListConfig"
          [selectionValues]="timeDropdown.selectedItems()"
          (overlayChanges)="timeDropdown.onSelectionUpdate($event)"
          (popoverClosing)="timeDropdown.closePopover()"
        />
      </da-dropdown>
      @if (!timeControl.valid && triggerForm.touched) {
        <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
          {{ i18nShared.Core_FieldRequired }}
        </div>
      }
    </div>
  </div>
}

<dgx-trigger-back-cancel-save-buttons
  [i18n]="i18nShared"
  [isSaving]="isSaving()"
  (clearTrigger)="onBack()"
  (saveEmitter)="onSave()"
  (cancelEmitter)="onCancel()"
  (backEmitter)="onBack()"
></dgx-trigger-back-cancel-save-buttons>
